import { useSuspenseQuery } from '@tanstack/react-query';
import { EmptyState, NavIcon, PageHeader } from '@wodi/ui';

import { can, sessionQuery } from '../api/session.ts';
import styles from '../home/home.module.css';
import { HOME_SECTIONS } from '../home/sections.tsx';

/**
 * Home (docs/plans/phase1-home-and-demo-data.md §3): what the signed-in person can act on
 * at this facility, one section per area their permissions reach.
 */
export function HomePage() {
  const { data: session } = useSuspenseQuery(sessionQuery);
  if (session === null) return <PageHeader title="Home" />;
  const visible = HOME_SECTIONS.filter((section) => section.visible(session));
  // Nurses and clinicians work from a queue, not the front desk: for anyone who can't check
  // patients in, the queues come first so their own work is at the top of the page.
  const queuesFirst = !can(session, 'visits.open');
  const sections = queuesFirst
    ? [
        ...visible.filter((section) => section.id === 'queues'),
        ...visible.filter((section) => section.id !== 'queues'),
      ]
    : visible;
  return (
    <div className={styles.page}>
      <PageHeader title={`Welcome, ${session.user.displayName}`} />
      {sections.length === 0 ? (
        <EmptyState>
          Nothing to work on here yet. Ask an administrator if you expected to see work lists.
        </EmptyState>
      ) : (
        sections.map(({ id, title, icon, Component }) => (
          <section key={id} className={styles.section} aria-labelledby={`home-${id}`}>
            <h2 id={`home-${id}`} className={styles.sectionHeading}>
              <span className={styles.chip}>
                <NavIcon name={icon} />
              </span>
              {title}
            </h2>
            <Component session={session} />
          </section>
        ))
      )}
    </div>
  );
}
